import { APIRoute } from '@/modules/utils'
import { MapBoxAddress } from '@/data'

export const Route: APIRoute = {
  method: 'GET',
  path: '/v2/mapbox/autocomplete',
}

export type SearchParams =
  | {
      addressText: string
    }
  | { latitude: number; longitude: number }

export type Response = MapBoxAddress[]
